import { axiosInstance } from "./api";

export type ICartAdd = {
  article: string;
  brand: string;
  name: string;
  exist: string;
  price: number;
  providerId: string;
  priceListId: string;
  count: number;
};

export const cartAdd = async (props: ICartAdd) => {
  const res = await axiosInstance.post("/api/v2/cart/add", props);
  return res.data;
};

export type TCartUpdate = { id: string; count: number };

export const cartUpdate = async (props: TCartUpdate) => {
  const res = await axiosInstance.post("/api/v2/cart/update", props);
  return res.data;
};

export type TCartRemove = { ids: string[] };

export const cartRemove = async (props: TCartRemove) => {
  const res = await axiosInstance.post("/api/v2/cart/remove", props);
  return res.data;
};

export const cartGet = async () => {
  const res = await axiosInstance.get("/api/v2/cart");
  return res.data;
};
